module.exports = __webpack_public_path__ + "Hamburger_icon.svg?4dc4aca5670d9bd26dd00cae75e848d1";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/icons/Hamburger_icon.svg
// module id = 591
// module chunks = 0